import { render, staticRenderFns } from "./PrisonerIncentives.vue?vue&type=template&id=25fac6f0"
import script from "./PrisonerIncentives.vue?vue&type=script&lang=js"
export * from "./PrisonerIncentives.vue?vue&type=script&lang=js"
import style0 from "./PrisonerIncentives.vue?vue&type=style&index=0&id=25fac6f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports